import { Content } from '@lyrahealth-inc/shared-app-logic/src/models/assignments/Assignments'

import { baseApi } from '../../data/baseApi'

type GetContentsByProgramIdArgs = {
  programId: string
}

const contentsMetadataApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getContentsByProgramId: builder.query<Content[], GetContentsByProgramIdArgs>({
      query: ({ programId }) => ({
        method: 'get',
        url: `/lt/v1/contentsmetadata`,
        params: { program_id: programId },
      }),
      transformResponse: (response: Content[]) => {
        return response.filter((content) => content.group !== 'assessment')
      },
    }),
  }),
})

export const { useLazyGetContentsByProgramIdQuery } = contentsMetadataApi
export default contentsMetadataApi
